module.exports = __webpack_public_path__ + "img/img14.d31b4f24.png";